import { useContext, useCallback } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useStore = () => {
  const { api } = useContext(GlobalContext);

  const postRequest = useCallback(
    async (endpoint, payload = {}) => {
      const response = await api.post(endpoint, payload);
      return response?.data;
    },
    [api]
  );

  const getStores = async () => {
    const data = await postRequest(
      "/Order/v2.0/getStoresInstamart",
      {}
    );

    return data?.response || [];
  };

  const getStoreItems = async (fkUserId) => {
    const response = await api.post(
      `/Order/v2.0/getSyncItemsInstamartAdmin?fk_userid=${fkUserId}`,
      {}
    );

    return response?.data?.response || [];
  };

  const updateItemStatus = async (payload) => {
    const data = await postRequest(
      "/Order/UpdateMenuItemAdmin",
      payload
    );

    return data;
  };

  return {
    getStores,
    getStoreItems,
    updateItemStatus,
  };
};

export default useStore;